import axiosOverlay from '../../js/axiosOverlay'

const state = {
    logements: JSON.stringify([]),
    selectedLogement: null
};

const getters = {
    logements: state => state.logements,
    selectedLogement: state => state.selectedLogement,
    getLogementsByEntree: (state) => (selectEntree) => {
        return JSON.parse(state.logements).filter(logement => logement.entree === selectEntree)
    }
};

const mutations = {
    SET_LOGEMENTS(state, logements) {
        state.logements = logements;
    },
    SET_SELECTED_LOGEMENT(state, logement) {
        state.selectedLogement = logement;
    }
};

const actions = {
    async loadLogementsFromAPI({ commit, state }, partenaire) {
        if (partenaire && state.logements === JSON.stringify([])) {
            // Utilisation de la syntaxe: uniq = [...new Set(array)]; pour dédoublonner les éléments
            let entreesPartnr = [...new Set(JSON.parse(partenaire).filter(p => !p.programme).map(p => p.entree))]; // Uniquement les entrées sans programmes
            let programmePartnr = [...new Set(JSON.parse(partenaire).map(p => p.programme))];
            let url = "";
            let baseUrl = process.env.VUE_APP_API_URL + "/modules?";
            let config;

            let maxCount = 195; // Gestion des limites d'URL

            while (entreesPartnr.length > 0) {
                url = baseUrl + "&entree=" + JSON.stringify(entreesPartnr.slice(0, maxCount));
                config = {
                    method: 'get',
                    url: url,
                    headers: {}
                };

                try {
                    const response = await axiosOverlay(config);
                    let currentLogements = JSON.parse(state.logements);
                    let newLogements = JSON.stringify(
                        [...new Set([
                            ...currentLogements,
                            ...response.data
                        ])]
                    );
                    commit('SET_LOGEMENTS', newLogements);
                } catch (error) {
                    console.log(error);
                }
                entreesPartnr = entreesPartnr.slice(maxCount);
            }

            maxCount = 390; // Programmes

            while (programmePartnr.length > 0) {
                url = baseUrl + "&programme=" + JSON.stringify(programmePartnr.slice(0, maxCount));
                config = {
                    method: 'get',
                    url: url,
                    headers: {}
                };

                try {
                    const response = await axiosOverlay(config);
                    let currentLogements = JSON.parse(state.logements);
                    let newLogements = JSON.stringify(
                        [...new Set([
                            ...currentLogements,
                            ...response.data
                        ])]
                    );
                    commit('SET_LOGEMENTS', newLogements);
                } catch (error) {
                    console.log(error);
                }
                programmePartnr = programmePartnr.slice(maxCount);
            }
        }
    },
    
    setSelectedLogement({ commit }, logementID) {
        commit('SET_SELECTED_LOGEMENT', logementID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
